import cookieConfig from 'config/cookies/currencyCode'

import {setCookie} from '@vio/core/src/_web/utils/cookies'

export const persistCurrencyCode = (currencyCode: string) => {
  const {secure, sameSite, maxAge: expires} = cookieConfig.options
  setCookie(cookieConfig.name, currencyCode, {
    expires,
    secure,
    sameSite
  })
}
